import { render } from "./Step6.vue?vue&type=template&id=ee8754fe&scoped=true"
import script from "./Step6.vue?vue&type=script&lang=js"
export * from "./Step6.vue?vue&type=script&lang=js"

import "./Step6.vue?vue&type=style&index=0&id=ee8754fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee8754fe"]])

export default __exports__